import SC from "./style";
import { useState } from "react";
import { apiPost } from "api/callApi";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { regexTypes } from "utils/config";
import { showAlert } from "utils/helper";

function AddEditTenentGroup(props) {
  const { setOpenModalView, openModalView, onSuccess = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ tenentGroupName: "" });

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await apiPost("/v1/tenentgroup", data);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setData("");
      setOpenModalView(false);
      onSuccess();
    } catch (error) {
      console.error("Error:", error);
      showAlert({
        title: "Error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setLoading(false);
      setData("");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelTenentGroupModal = () => {
    setOpenModalView(false);
    setData("");
  };

  const AddTenentGroupModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Occupant Group Name"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <InputField
                name="tenentGroupName"
                value={data.tenentGroupName}
                onChange={handleChange}
                required
                style={{ width: "100%" }}
                // capitalize
                regexType={regexTypes.oneSpace}
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelTenentGroupModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: "#f7f9f7",
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Add"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={"New Occupant Group"}
          openModal={openModalView}
          renderBodyConditionally={AddTenentGroupModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData("");
          }}
        />
      )}
    </>
  );
}

export default AddEditTenentGroup;
